<template>
  <div>
    <transition name="el-zoom-in-top">
      <div class="dg_pasw_intensity" :style="{ top: top + 'px' }"
        v-show="!(intensity2 && intensity && intensity1) && value">
        <p><i class="icon success" :class="{ active: intensity }">&#xe62f;</i> 6-32个字符 </p>
        <p><i class="icon success" :class="{ active: intensity1 }">&#xe62f;</i> 至少包含大小写字母、数字、符号中的两种 </p>
        <p><i class="icon success" :class="{ active: intensity2 }">&#xe62f;</i> 避免使用连续或重复的字符（如123456、abcdef） </p>
        <i class="tree icon">&#x100dd;</i>
      </div>
    </transition>
  </div>
</template>
<script>

export default {
  name: 'dg-pasw-intensity',
  data() {
    return {

    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    top: {
      type: Number,
      default: 60
    },
    value: {
      type: [String, Number],
    }
  },



  computed: {
    intensity() {
      return /^.{6,32}$/.test(this.value)
    },
    intensity1() {

      let   hasLowercase = /[a-z]/.test(this.value);
      let   hasUppercase = /[A-Z]/.test(this.value);
      let   hasDigit = /\d/.test(this.value);
      let   hasSpecialChar = /[^a-zA-Z0-9]/.test(this.value);
      let charTypes = 0;
      if (hasLowercase) charTypes++;
      if (hasUppercase) charTypes++;
      if (hasDigit) charTypes++;
      if (hasSpecialChar) charTypes++;

      if (charTypes < 2) {
        return false;
      }
      return true
    },
    intensity2() {
      if (!this.value || this.value.length < 2) return false;
      // 检查是否包含连续的字母或数字
      let   sequences = ["abcdefghijklmnopqrstuvwxyz", "ABCDEFGHIJKLMNOPQRSTUVWXYZ", "0123456789"];

      for (let   sequence of sequences) {
        for (let i = 0; i <= sequence.length - 3; i++) {
          let   subSequence = sequence.substring(i, i + 3);
          if (this.value.includes(subSequence)) {
            return false;
          }
        }
      }
      // a17531
      // 检查是否包含重复的字符序列
      for (let i = 0; i <= this.value.length - 3; i++) {
        if (this.value[i] === this.value[i + 1] && this.value[i] === this.value[i + 2]) {
          return false;
        }
      }

      return true;

    }
  },

}
</script>
<style scoped lang="less">
.dg_pasw_intensity {
  background: #303133;
  border-radius: 2px;
  position: absolute;
  top: 55px;
  left: 0;
  z-index: 10;
  color: #C0C4CC;
  padding: 6px 13px;

  p {
    line-height: 18px;
    font-size: 11px;
  }

  .success {
    color: #fff;
  }

  i.active {
    color: #00B42A;
  }

  .tree {
    font-size: 16px;
    top: -10px;
    left: 10px;
    position: absolute;
    color: #303133;
    line-height: 18px;
  }
}
</style>
